var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.selectedItem
    ? _c(
        "div",
        [
          _c(
            "div",
            [
              _c("h6", {
                staticClass: "font-weight-bold no-wrap align-items-center mb-0",
                domProps: { textContent: _vm._s(_setup.layerTypeTitle) },
              }),
              _vm._v(" "),
              _c(_setup.ModalImportListItem, {
                attrs: { item: _setup.selectedItem, "prevent-action": true },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-4 align-items-center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-5" },
              [
                _c(_setup.ModalImportSearch, {
                  on: { "search-text-change": _setup.updateSearchText },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(_setup.ModalImportLayersTree, {
            staticClass: "my-2",
            attrs: { "tree-item": _setup.treeItem },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-12 col-sm-7" }, [
      _c("h6", { staticClass: "font-weight-bold no-wrap align-items-center" }, [
        _vm._v("Select the layers to import"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }